<template>
  <div>
    <template v-if="type == 'auto'">
      <template v-if="list.length<Number(maxLength)">
        <template v-if="multiple">
          <el-checkbox-group
            v-model="formValue"
            :disabled="disabled"
          >
            <el-checkbox-button
              v-for="item in list"
              :key="item[id]"
              :label="item[id]"
            >
              {{ item[label] }}
            </el-checkbox-button>
          </el-checkbox-group>
        </template>
        <template v-else>
          <el-radio-group
            v-model="formValue"
            :disabled="disabled"
          >
            <el-radio-button
              v-for="item in list"
              :key="item[id]"
              :label="item[id]"
            >
              {{ item[label] }}
            </el-radio-button>
          </el-radio-group>
        </template>
      </template>
      <template v-else>
        <el-select
          v-model="formValue"
          style="width: 100%;"
          :multiple="multiple"
          placeholder="请选择"
          :disabled="disabled"
        >
          <el-option
            v-for="item in list"
            :key="item[id]"
            :label="item[label]"
            :value="item[id]"
          />
        </el-select>
      </template>
    </template>
    <template v-if="type == 'select'">
      <el-select
        v-model="formValue"
        :multiple="multiple"
        placeholder="请选择"
        :disabled="disabled"
      >
        <el-option
          v-for="item in list"
          :key="item[id]"
          :label="item[label]"
          :value="item[id]"
        />
      </el-select>
    </template>
    <template v-if="type == 'button'">
      <template v-if="multiple">
        <el-checkbox-group
          v-model="formValue"
          :disabled="disabled"
        >
          <el-checkbox-button
            v-for="item in list"
            :key="item[id]"
            :label="item[id]"
          >
            {{ item[label] }}
          </el-checkbox-button>
        </el-checkbox-group>
      </template>
      <template v-else>
        <el-radio-group
          v-model="formValue"
          :disabled="disabled"
        >
          <el-radio-button
            v-for="item in list"
            :key="item[id]"
            :label="item[id]"
          >
            {{ item[label] }}
          </el-radio-button>
        </el-radio-group>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SelectOrRadio',
  model: {
    prop: 'value', // 指向props的参数名
    event: 'change'// 事件名称
  },
  props: {
    value: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Object | Array | Number | Boolean | String,
      default: undefined
    },
    type: { // 展示类型  auto:自动 select:下拉框 button:按钮
      type: String,
      default: 'auto'
    },
    maxLength: { // 显示为按钮的最大长度,type为auto时有效   超出显示为下拉框
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number,
      default: 5
    },
    multiple: { // 是否多选
      type: Boolean,
      default: false
    },
    list: { // 选项
      type: Array,
      default() {
        return []
      }
    },
    label: { // 选项所展示的名字
      type: String
    },
    id: { // 选项的值
      type: String
    },
    disabled: Boolean
  },
  data() {
    return {
      formValue: ''
    }
  },
  watch: {
    formValue(val) {
      this.$emit('change', val)
    },
    value(val) {
      this.formValue = val
    }
  },
  created() {
    this.formValue = this.value
  }
}
</script>

<style scoped lang="less">

</style>
